let isMobile;
export const isMobileDevice = () => {
    if (isMobile !== undefined) {
        return isMobile;
    }
    // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgentData
    const userAgentData = navigator["userAgentData"];
    if (userAgentData && !!userAgentData.mobile) {
        isMobile = true;
    }
    else if (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
        isMobile = true;
    }
    else {
        isMobile = false;
    }
    return isMobile;
};
